import { ReactNode, useEffect } from 'react';
import Spinner from '../share/Spinner';
import useAdminUser from '../contexts/AdminUserContext';
import adminService from '../utils/api-calls/adminService';

export default function AdminPageGuard({ children }: { children: ReactNode }) {
  const adminUser = useAdminUser();

  useEffect(() => {
    adminService.me().then(({ email }) => {
      if (!email) {
        adminUser.logout();
      }
    });
  }, [adminUser]);

  if (!adminUser.isInitialized) {
    return <Spinner />;
  }

  return <>{children}</>;
}
